import axios from 'axios';

const API_URL = '/ys_api.php';

export const getParticipants = async () => {
    const res = await axios.get(API_URL, { params: { action: 'read' } });
    return res.data;
};

export const saveParticipant = async (participant) => {
    const res = await axios.post(API_URL + '?action=save', participant);
    return res.data;
};

export const deleteParticipant = async (name) => {
    const res = await axios.post(API_URL + '?action=delete', { name });
    return res.data;
};
